<div *ngIf="!editDetails">
    <div class="row">
      <div class="col-12 text-right edit-btn mt-3">
        <ng-container *ngIf="!viewMode && showEditButton">
          <button class="back-button button-width-icon-left btn-pos-top-right" (click)="handleEdit()">
            <!-- <img src="../../../../../assets/images/edit.png" alt="" /> -->
            <i class="fa fa-pencil"></i>
            Edit
          </button>
        </ng-container>
      </div>
    </div>
<!-- <h5 class="labelText mt-2">Personal Details</h5>
<div class="row row-cols-5">
    <div class="col mb-2">
        <p class="label-light m-0">First Name</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Last Name</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Middle Name</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Gender</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Date of Birth</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Mobile No</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Alternate Mobile No</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Email Id</p>
        <label class="label-dark wrap-word"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Marital Status</p>
        <label class="label-dark wrap-word"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Social Security Number</p>
        <label class="label-dark"></label>
    </div>

</div>
<div class="col-3">
    <div>
        <p class="label-cls mb-2">Are you a Lawful Permanent Resident?
        </p>
        <label class="label-dark">No</label>
    </div>
</div> -->

<!-- <h5 class="labelText mt-2">Address Details</h5>
<div class="row row-cols-5">
    <div class="col mb-2 word-wrap">
        <p class="label-light m-0">Address 1</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2 word-wrap">
        <p class="label-light m-0">Address 2</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">City</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Country</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">State</p>
        <label class="label-dark"></label>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Locality</p>
        <label class="label-dark"></label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">Zip / Postal code</p>
        <label class="label-dark"></label>
    </div>
</div> -->
<h5 class="labelText mt-2">Federal W4 Form</h5>
<div class="row row-cols-5">
    <div class="col mb-2 word-wrap">
        <p class="label-light m-0">Filing Status</p>
        <label class="label-dark wrap-word">{{
          w4Details?.federalFilingStatus ? w4Details?.federalFilingStatus : "--"
          }}</label>
    </div>
    <div class="col mb-2 word-wrap">
        <p class="label-light m-0">Married Filing Jointly</p>
        <label class="label-dark">{{
          w4Details?.federalMarried ? w4Details?.federalMarried : "--"
          }}</label>
    </div>
</div>

<div class="row">
    <h6 class="labelText mt-2">Uploaded Document</h6>
    <p-table [value]="federalFiles" [resizableColumns]="true" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
            <tr>
              <!-- <th style="width:5%"><p-checkbox *ngIf="bulkDownloadCheckboxes['Experience']" value="true" inputId="documentTypeExperience" binary="true"  name="groupnameExperience" [(ngModel)]="bulkDownloadCheckboxes['Experience']['isAllSelected']"
                  (onChange)="selectAllDocs($event,bulkDownloadCheckboxes['Experience'])" [disabled]="!loadData.Experience?.length"></p-checkbox></th> -->
                <th>Type</th>
                <th>Name</th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-loadData>
            <tr>
              <!-- <td style="width:5%"><p-checkbox *ngIf="bulkDownloadCheckboxes['Experience']" value="true" inputId="documentTypeExperience{{loadData?.id}}" binary="true" name="groupname{{loadData?.id}}" [(ngModel)]="bulkDownloadCheckboxes['Experience']['childItems'][loadData['itemIndex']]['isSelected']" (onChange)="selectDoc($event,bulkDownloadCheckboxes['Experience'])"></p-checkbox></td> -->
              <td>{{loadData?.fileCategory}}</td>
                <td>{{loadData?.fileName}}</td>
                <td>
                    <div class="row">
                        <div><i class="fa fa-download pr-2 icn" title="Download" (click)="download(loadData)"></i> </div>
                        <div> <i class="fa fa-trash icn" title="Delete" (click)="deleteDoc(loadData)"></i> </div>
                        </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-loadData>
            <tr>
              <td [attr.colspan]="3">
                 No records found
              </td>
            </tr>
          </ng-template>
    </p-table>
   
</div>
<h5 class="labelText mt-2">State W4 Form</h5>
<div class="row row-cols-5">
    <div class="col mb-2 word-wrap">
        <p class="label-light m-0">State</p>
        <label class="label-dark">{{
          w4Details?.stateW4FormState ? w4Details?.stateW4FormState : "--"
          }}</label>
    </div>
    <div class="col mb-2 word-wrap">
        <p class="label-light m-0">Filing Status</p>
        <label class="label-dark wrap-word">{{
          w4Details?.stateW4FormFilingStatus ? w4Details?.stateW4FormFilingStatus : "--"
          }}</label>
    </div>
</div>
<div class="row">
    <h6 class="labelText mt-2">Uploaded Document</h6>
    <p-table [value]="stateFiles" [resizableColumns]="true" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
            <tr>
              <!-- <th style="width:5%"><p-checkbox *ngIf="bulkDownloadCheckboxes['Experience']" value="true" inputId="documentTypeExperience" binary="true"  name="groupnameExperience" [(ngModel)]="bulkDownloadCheckboxes['Experience']['isAllSelected']"
                  (onChange)="selectAllDocs($event,bulkDownloadCheckboxes['Experience'])" [disabled]="!loadData.Experience?.length"></p-checkbox></th> -->
                <th>Type</th>
                <th>Name</th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-loadData>
            <tr>
              <!-- <td style="width:5%"><p-checkbox *ngIf="bulkDownloadCheckboxes['Experience']" value="true" inputId="documentTypeExperience{{loadData?.id}}" binary="true" name="groupname{{loadData?.id}}" [(ngModel)]="bulkDownloadCheckboxes['Experience']['childItems'][loadData['itemIndex']]['isSelected']" (onChange)="selectDoc($event,bulkDownloadCheckboxes['Experience'])"></p-checkbox></td> -->
              <td>{{loadData?.fileCategory}}</td>
                <td>{{loadData?.fileName}}</td>
                <td>
                    <div class="row">
                        <div><i class="fa fa-download pr-2 icn" title="Download" (click)="download(loadData)"></i> </div>
                        <div> <i class="fa fa-trash icn" title="Delete" (click)="deleteDoc(loadData)"></i> </div>
                        </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-loadData>
            <tr>
              <td [attr.colspan]="3">
                 No records found
              </td>
            </tr>
          </ng-template>
    </p-table>
   
</div>
</div>
<div *ngIf="editDetails" class="edit-bank-details">
    <form [formGroup]="w4DetailsForm" #f="ngForm"
      (ngSubmit)="saveW4Data()">
      <!-- <div class="row mt-2">
        <div class="col-3">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">First Name</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (w4DetailsForm.get('bankName').touched || submitted) &&
                w4DetailsForm.get('bankName').errors?.required
            }" pattern="^[a-zA-Z ]*$" formControlName="bankName" placeholder="Enter your Bank Name" />
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('bankName').touched || submitted) &&
              w4DetailsForm.get('bankName').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('bankName').touched || submitted) &&
              w4DetailsForm.get('bankName').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls">Last Name</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (w4DetailsForm.get('routingNumber').touched || submitted) &&
                w4DetailsForm.get('routingNumber').errors?.pattern
            }" pattern="^[0-9]*$" formControlName="routingNumber" placeholder="Enter your Middle Name" />
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('routingNumber').touched || submitted) &&
              w4DetailsForm.get('routingNumber').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Middle Name</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (w4DetailsForm.get('accountType').touched || submitted) &&
                w4DetailsForm.get('accountType').errors?.required
            }" pattern="^[a-zA-Z ]*$" formControlName="accountType" placeholder="Enter Account Type" />
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('accountType').touched || submitted) &&
              w4DetailsForm.get('accountType').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('accountType').touched || submitted) &&
              w4DetailsForm.get('accountType').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Gender</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (w4DetailsForm.get('accountNumber').touched || submitted) &&
                w4DetailsForm.get('accountNumber').errors?.required
            }" pattern="^[0-9]*$" formControlName="accountNumber" placeholder="Enter Account Number" />
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('accountNumber').touched || submitted) &&
              w4DetailsForm.get('accountNumber').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('accountNumber').touched || submitted) &&
              w4DetailsForm.get('accountNumber').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls">Date of Birth</p>
          <mat-form-field appearance="outline" class="mt-0 date-field">
            <input formControlName="nomineeDob" matInput min="1920-12-31" [max]="currentDate" [matDatepicker]="nomineeDob"
              placeholder="MM/DD/YYYY" readonly (click)="nomineeDob.open()" />
            <mat-datepicker-toggle matSuffix [for]="nomineeDob"></mat-datepicker-toggle>
            <mat-datepicker #nomineeDob></mat-datepicker>
          </mat-form-field>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('nomineeDob').touched || submitted) &&
              w4DetailsForm.get('nomineeDob').errors?.required &&
              !w4DetailsForm.get('nomineeDob').errors?.matDatepickerParse
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('nomineeDob').touched || submitted) &&
              w4DetailsForm.get('nomineeDob').errors?.required &&
              w4DetailsForm.get('nomineeDob').errors?.matDatepickerParse
            ">
            {{ getGlobalErrorMessages("INVALID_FORMAT") }}
          </span>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('nomineeDob').touched || submitted) &&
              w4DetailsForm.get('nomineeDob').errors?.currentDateError
            ">
            {{ getGlobalErrorMessages("INVALID_DATE") }}
          </span>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('nomineeDob').touched || submitted) &&
              w4DetailsForm.get('nomineeDob').errors?.patternError
            ">
            {{ getGlobalErrorMessages("INVALID_FORMAT") }}
          </span>
        </div>
      </div> -->
      <!-- <div class="row mt-2">
        <div class="col-3">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Mobile No.<small> (10 digits)
            </small></p>
          <input type="text" [ngClass]="{
                'im-input-error':
                  ((w4DetailsForm.get('phoneNo').touched || submitted) &&
                  w4DetailsForm.get('phoneNo').hasError('pattern')) ||
                  ((w4DetailsForm.get('phoneNo').touched || submitted) &&
                  w4DetailsForm.get('phoneNo').hasError('required'))
              }" class="im-input col-md" formControlName="phoneNo" minlength="10" maxlength="10"
            placeholder="Enter" />
          <span class="invalid-message" *ngIf="
                (w4DetailsForm.get('phoneNo').touched || submitted) &&
                w4DetailsForm.get('phoneNo').hasError('required')
              ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
                (w4DetailsForm.get('phoneNo').touched || submitted) &&
                w4DetailsForm.get('phoneNo').hasError('pattern')
              ">
            {{ getGlobalErrorMessages("INVALID_NUMBER") }}
          </span>
          <span class="invalid-message" *ngIf="w4DetailsForm.get('phoneNo').errors?.maxlength">
            {{ getGlobalErrorMessages("MAXLENGTH") + "10" }}
          </span>
          <span class="invalid-message" *ngIf="w4DetailsForm.get('phoneNo').errors?.minlength">
            {{ getGlobalErrorMessages("MINLENGTH") + "10 Numbers" }}
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Alternate Mobile No.<small> (10 digits)
            </small></p>
          <input type="text" [ngClass]="{
                'im-input-error':
                  ((w4DetailsForm.get('phoneNo').touched || submitted) &&
                  w4DetailsForm.get('phoneNo').hasError('pattern')) ||
                  ((w4DetailsForm.get('phoneNo').touched || submitted) &&
                  w4DetailsForm.get('phoneNo').hasError('required'))
              }" class="im-input col-md" formControlName="phoneNo" minlength="10" maxlength="10"
            placeholder="Enter" />
          <span class="invalid-message" *ngIf="
                (w4DetailsForm.get('phoneNo').touched || submitted) &&
                w4DetailsForm.get('phoneNo').hasError('required')
              ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
                (w4DetailsForm.get('phoneNo').touched || submitted) &&
                w4DetailsForm.get('phoneNo').hasError('pattern')
              ">
            {{ getGlobalErrorMessages("INVALID_NUMBER") }}
          </span>
          <span class="invalid-message" *ngIf="w4DetailsForm.get('phoneNo').errors?.maxlength">
            {{ getGlobalErrorMessages("MAXLENGTH") + "10" }}
          </span>
          <span class="invalid-message" *ngIf="w4DetailsForm.get('phoneNo').errors?.minlength">
            {{ getGlobalErrorMessages("MINLENGTH") + "10 Numbers" }}
          </span>
        </div>
        <div class="col-3" formArrayName="emailContacts">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Email Id</p>
          <ng-container *ngFor="
              let x of w4DetailsForm.get('emailContacts')['controls'];
              index as i
            ">
            <div [formGroupName]="i">
              <input type="text" class="im-input" [ngClass]="{
                  'im-input-error':
                    ((x.get('email').touched || submitted) &&
                      x.get('email').hasError('pattern')) ||
                    ((x.get('email').touched || submitted) &&
                      x.get('email').hasError('required'))
                }" formControlName="email" placeholder="Enter"
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$" />
            </div>
            <span class="invalid-message" *ngIf="
                (x.get('email').touched || submitted) &&
                x.get('email').hasError('required')
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
            <span class="invalid-message" *ngIf="
                (x.get('email').touched || submitted) &&
                x.get('email').hasError('pattern')
              ">
              {{ getGlobalErrorMessages("INVALID_EMAIL") }}
            </span>
          </ng-container>
        </div>
        <div class="col-3">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">Marital Status</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (w4DetailsForm.get('bankNomineeName').touched || submitted) &&
                w4DetailsForm.get('bankNomineeName').errors?.required
            }" pattern="^[a-zA-Z ]*$" formControlName="bankNomineeName" placeholder="Enter Branch Name" />
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('bankNomineeName').touched || submitted) &&
              w4DetailsForm.get('bankNomineeName').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('bankNomineeName').touched || submitted) &&
              w4DetailsForm.get('bankNomineeName').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABETS_ONLY") }}
          </span>
        </div>
        <div class="col-3">
          <p class="label-cls">Social Security Number</p>
          <div class="ssn-field">
            <input type="text" class="im-input ssn-input" formControlName="ssn"
               placeholder="SSN" minlength="9" maxlength="9" />
            <mat-icon matSuffix matTooltip="Show/Hide">
              </mat-icon>
          </div>
          <span class="invalid-message">
            Please Enter 9 Digits
          </span>
        </div>
    
      </div> -->
<!-- 
      <div class="row mt-2">
        <div class="col-3">
          <div>
            <p class="label-cls mb-2" [class.required]="beneficiaryType==='self'">Are you a Lawful Permanent Resident?
            </p>
  
            <p-radioButton labelStyleClass="profileRadio" formControlName="isLpr" name="isLpr" [value]="1" label="Yes"
              (onClick)="handleIsLprChanges()" inputId="YES">
            </p-radioButton>
            <p-radioButton labelStyleClass="profileRadio" class="ml-2" formControlName="isLpr" name="isLpr" [value]="0"
              (onClick)="handleIsLprChanges()" label="No" inputId="NO">
            </p-radioButton>
  
  
          </div>
        </div>
      </div> -->
        <!-- Address Details -->
    <!-- <div formArrayName="address"> -->
      <!-- <div>
        <div class="row mt-2">
          <div class="col-8">
            <p class="label-cls" [class.required]="beneficiaryType==='self'">Address 1</p>
            <input type="text" class="im-input col-md" [ngClass]="{
                'im-input-error':
                  (submitted ||
                    w4DetailsForm
                      .get('address')
                      ['controls']['0'].get('addressLine1').touched) &&
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('addressLine1').errors?.required
              }" formControlName="addressLine1" placeholder="Address 1" maxLength="99" />
            <span class="invalid-message" *ngIf="
                (submitted ||
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('addressLine1').touched) &&
                w4DetailsForm
                  .get('address')
                  ['controls']['0'].get('addressLine1').errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-8">
            <p class="label-cls">Address 2 <i
                pTooltip='Enter Apartment, Suite, Floor number with the prefix Apt, Ste or Flr respectively. This will be automatically mapped to the Apartment, Suite and Floor fields in the forms'
                class="pi pi-info-circle"></i></p>
            <input type="text" class="im-input col-md" [ngClass]="{
                'im-input-error':
                  submitted &&
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('addressLine2').errors?.required
              }" formControlName="addressLine2" placeholder="Address 2" maxLength="99" />
            <span class="invalid-message" *ngIf="
                submitted &&
                w4DetailsForm
                  .get('address')
                  ['controls']['0'].get('addressLine2').errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-4">
            <p class="label-cls">Locality</p>
            <input class="im-input" formControlName="locality" type="text" placeholder="locality" />
          </div>
          <div class="col-4" formGroupName="countryCode">
            <p class="label-cls" [class.required]="beneficiaryType==='self'">Country</p>
            <p-dropdown [options]="listCountry" formControlName="countryCode" optionLabel="countryName"
              optionValue="countryCode" (onChange)="
            handleCountryChange($event.value, 'Current');
            resetStateOnCountryChange(0)
          " placeholder="Select Country"></p-dropdown>
            <span class="invalid-message" *ngIf="
                (submitted ||
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('countryCode').touched) &&
                w4DetailsForm
                  .get('address')
                  ['controls']['0'].get('countryCode')
                  .get('countryCode').errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="col-4" *ngIf="listStatesCurrent.length > 0">
            <p class="label-cls" [class.required]="beneficiaryType==='self'">State</p>
            <p-dropdown [options]="listStatesCurrent" formControlName="stateProvinceCode"
              optionLabel="stateProvinceName" optionValue="stateProvinceCode"
              (onChange)="handleStateChange($event.value, 0)" placeholder="Select State"></p-dropdown>
            <span class="invalid-message" *ngIf="
                (submitted ||
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('stateProvinceCode').touched) &&
                w4DetailsForm
                  .get('address')
                  ['controls'][0].get('stateProvinceCode').errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="col-4" *ngIf="listStatesCurrent.length <= 0">
            <p class="label-cls" [class.required]="beneficiaryType==='self'">State</p>
            <input class="im-input" [ngClass]="{
                'im-input-error':
                  (submitted ||
                    w4DetailsForm
                      .get('address')
                      ['controls']['0'].get('stateProvinceName').touched) &&
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('stateProvinceName').errors?.required
              }" formControlName="stateProvinceName" type="text" placeholder="State" />
            <span class="invalid-message" *ngIf="
                (submitted ||
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('stateProvinceName').touched) &&
                w4DetailsForm
                  .get('address')
                  ['controls']['0'].get('stateProvinceName').errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-4">
            <p class="label-cls" [class.required]="beneficiaryType==='self'">City</p>
            <input class="im-input" [ngClass]="{
                'im-input-error':
                  (submitted ||
                    w4DetailsForm
                      .get('address')
                      ['controls']['0'].get('city').touched) &&
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('city').errors?.required
              }" formControlName="city" type="text" placeholder="City" />
            <span class="invalid-message" *ngIf="
                (submitted ||
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('city').touched) &&
                w4DetailsForm.get('address')['controls']['0'].get('city')
                  .errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="col-4">
            <p class="label-cls" [class.required]="beneficiaryType==='self'">Zip / Postal Code</p>
            <input class="im-input" [ngClass]="{
                'im-input-error':
                  ((submitted ||
                    w4DetailsForm
                      .get('address')
                      ['controls']['0'].get('postCode').touched) &&
                    w4DetailsForm
                      .get('address')
                      ['controls']['0'].get('postCode').errors?.pattern) ||
                  (submitted &&
                    w4DetailsForm
                      .get('address')
                      ['controls']['0'].get('postCode').errors?.required)
              }" formControlName="postCode" type="text" placeholder="Zip Code" maxLength="10" />
            <span class="invalid-message" *ngIf="
                (submitted ||
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('postCode').touched) &&
                w4DetailsForm
                  .get('address')
                  ['controls']['0'].get('postCode').errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
            <span class="invalid-message" *ngIf="
                (submitted ||
                  w4DetailsForm
                    .get('address')
                    ['controls']['0'].get('postCode').touched) &&
                w4DetailsForm
                  .get('address')
                  ['controls']['0'].get('postCode').errors?.pattern
              ">
              {{ getGlobalErrorMessages("ZIPCODE_ONLY") }}
            </span>
          </div>
        </div>
      </div> -->
    <!-- </div> -->
    <h5 class="labelText mt-2">Federal W4 Form</h5>
    <div class="row mt-2">
      
      <div class="col-3">
        <p class="label-cls text-label">Filing Status</p>
        <input type="text" class="im-input" [ngClass]="{
            'im-input-error':
              (w4DetailsForm.get('federalFilingStatus').touched || submitted) &&
              w4DetailsForm.get('federalFilingStatus').errors?.pattern
          }" pattern="^[a-zA-Z ]*$" formControlName="federalFilingStatus" placeholder="Enter Filing Status" />
        <span class="invalid-message" *ngIf="
            (w4DetailsForm.get('federalFilingStatus').touched || submitted) &&
            w4DetailsForm.get('federalFilingStatus').errors?.pattern
          ">
          {{ getGlobalErrorMessages("ALPHABET_ONLY") }}
        </span>
      </div>
      <div class="col-3">
        <div>
          <p class="label-cls mb-2" [class.required]="beneficiaryType==='self'">Married Filing Jointly</p>
      
          <p-radioButton labelStyleClass="profileRadio" formControlName="federalMarried" name="federalMarried" [value]="'Yes'" label="Yes"
            (onChange)="handleIsJointlyChanges('Yes')" inputId="YES">
          </p-radioButton>
          
          <p-radioButton labelStyleClass="profileRadio" class="ml-2" formControlName="federalMarried" name="federalMarried" [value]="'No'"
            (onChange)="handleIsJointlyChanges('No')" label="No" inputId="NO">
          </p-radioButton>
        </div>
      </div>
      
     
    </div>
      <div class="row mt-4">
        <p *ngIf="!viewMode" class="lbl-text-2">Add the Document</p>
        <app-file-upload style="width: 100%" [configurations]="documentFileUploadConfigurations"></app-file-upload>
      </div>
      <h5 class="labelText mt-2">State W4 Form</h5>
      <div class="row mt-2">
        <div class="col-4" *ngIf="listStatesCurrent.length > 0">
          <p class="label-cls" [class.required]="beneficiaryType==='self'">State</p>
          <div class="dd-position">
          <p-dropdown [options]="listStatesCurrent" formControlName="stateW4FormState"
          optionLabel="stateProvinceName" optionValue="stateProvinceName"
          (onChange)="handleStateChange($event.value)" placeholder="Select State" [style]="{'width':'100%'}"></p-dropdown>
          <span class="invalid-message" *ngIf="
          (w4DetailsForm.get('stateW4FormState').touched || submitted) &&
          w4DetailsForm.get('stateW4FormState').errors?.pattern">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
        </div>
        </div>
        
        <div class="col-3">
          <p class="label-cls text-label">Filing Status</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (w4DetailsForm.get('stateW4FormFilingStatus').touched || submitted) &&
                w4DetailsForm.get('stateW4FormFilingStatus').errors?.pattern
            }" pattern="^[a-zA-Z ]*$" formControlName="stateW4FormFilingStatus" placeholder="Enter Filing Status" />
          <span class="invalid-message" *ngIf="
              (w4DetailsForm.get('stateW4FormFilingStatus').touched || submitted) &&
              w4DetailsForm.get('stateW4FormFilingStatus').errors?.pattern
            ">
            {{ getGlobalErrorMessages("ALPHABET_ONLY") }}
          </span>
        </div>
       
      </div>
        <div class="row mt-4">
          <p *ngIf="!viewMode" class="lbl-text-2">Add the Document</p>
          <app-file-upload style="width: 100%" [configurations]="stateFileUploadConfigurations"></app-file-upload>
        </div>
      <div class="row">
        <div class="col-12 text-right">
          <button class="back-button d-inline-flex align-items-center pr-3 pl-3 mr-3" *ngIf="w4UpdateProfile"
            (click)="backToTask()">
            <i class="fa fa-chevron-circle-left pr-1" aria-hidden="true"></i>
            Back
          </button>
          <lib-save-as-draft class="mr-3"
            (onClickSaveAsDraft)="saveAsDraft($event)" [showSaveIcon]="true"
            [formToBeSaved]="w4DetailsForm"></lib-save-as-draft>
          <button type="submit" class="btn btn-success button-width-icon-left mr-3"
            [disabled]="w4DetailsForm.invalid" [ngClass]="{'invalidBtn': w4DetailsForm.invalid }">
            <i class="fa fa-floppy-o"></i>
            Save
          </button>
          <button *ngIf="!editModeVal" type="button" class="back-button button-width-icon-left"
            (click)="clearProfileData(f)">
            <i class="fa fa-times-circle"></i>
            Cancel
          </button>
        </div>
      </div>
    </form>
 
  </div>